import { connectKeycloak } from "@plugins/keycloak"
import { reactive } from "vue"

export const keycloakState = reactive({
  available: false,
  instance: undefined,
  userName: '',
  getInstance: getKeycloakInstance
})

async function getKeycloakInstance(keycloakConfig) {
  if (!keycloakState.instance) {
    return connectKeycloak(keycloakConfig)
      .then(instance => {
        keycloakState.available = true
        keycloakState.instance = instance
        return instance
      })
  } else {
    return keycloakState.instance
  }
}
